import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router'

import { appHref } from '@/config/config'

/** Insure's app moved from /app to /insure, so an old link opens the page it always did. */
export function MovedToInsure() {
  const { pathname, search, hash } = useLocation()
  return <Navigate to={`/insure${pathname.replace(/^\/app/i, '')}${search}${hash}`} replace />
}

/** The marketing site serves no Insure app, so an /insure link there opens the same page on the app host. */
export function OnTheAppHost() {
  const { pathname, search, hash } = useLocation()
  useEffect(() => window.location.replace(appHref(`${pathname}${search}${hash}`)), [pathname, search, hash])
  return null
}
